import { Component } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent {
  message:string = '';
  name:string = '';
  constructor(public util:UtilService){
    this.init();
  this.util.userLoggedInEventCalled.subscribe(()=>{
    this.util.route('home');
    this.init();
  })
  }
  init(){
    if(!this.util.loanDetails) return;
    this.message = this.util.config.find((data:any)=> data.name === 'WELCOME_LETTER').value;
    this.name = this.util.loanDetails?.institutionInfo?.candidateName?.split(' ')[0];
  }
}
